<template>
    <div v-if="hasFieldToDisplay()">
        <div class="tabulation-title">
            <h5>
                <v-icon class="blue--text text--darken-2">label</v-icon> Accès aux personnes en situation de handicap
            </h5>
        </div>

        <div class="form-container mr-auto ml-auto mt-3">

            <div v-if="hasField('DISABLED_RECEPTION')" style="margin-bottom: 30px">
                <label>Accueil de personnes en situation de handicap</label>
                <v-radio-group row class="mt-auto mb-auto" :value="disabledReception"
                    @change="updateBooleanElement([$event, 'DISABLED_RECEPTION'])" style="padding-top: 0 !important;">
                    <v-radio label="Oui" class="text" :value="true"></v-radio>
                    <v-radio label="Non" class="text" :value="false"></v-radio>
                    <v-radio label="Non communiqué" class="text" value="null"></v-radio>
                </v-radio-group>
            </div>

            <v-autocomplete v-if="hasFamilyElement('LabelTourismeHandicap') &&
            (labelTourismeHandicap.length > 0 || !getField('LabelTourismeHandicap').skipped)"
                            :value="labelTourismeHandicap" :items="getFamilyByCode('LabelTourismeHandicap')" chips
                @change="updateOrDeleteElement($event, 'labelTourismeHandicap')" deletable-chips
                label="Labels Tourisme et Handicap" item-text="label" return-object multiple outlined>
            </v-autocomplete>

            <v-autocomplete v-else-if="hasFamilyElement('LabelTourismeHandicap')
            && labelTourismeHandicap.length === 0 && getField('LabelTourismeHandicap').skipped"
                            :items="['Non concerné']"
                            chips
                            :value="'Non concerné'"
                            label="Labels Tourisme et Handicap"
                            outlined>
            </v-autocomplete>

            <v-autocomplete v-if="hasFamilyElement('AccessibilityCriteriaForHearingLoss') &&
             (accessibilityCriteriaForHearingLoss.length >> 0 || !getField('AccessibilityCriteriaForHearingLoss').skipped)"
                :value="accessibilityCriteriaForHearingLoss"
                :items="getFamilyByCode('AccessibilityCriteriaForHearingLoss')" chips
                @change="updateOrDeleteElement($event, 'accessibilityCriteriaForHearingLoss')" deletable-chips
                label="Critères d'accessibilité pour déficience auditive" item-text="label" return-object multiple
                outlined>
            </v-autocomplete>

            <v-autocomplete v-else-if="hasFamilyElement('AccessibilityCriteriaForHearingLoss') &&
            accessibilityCriteriaForHearingLoss.length === 0 && getField('AccessibilityCriteriaForHearingLoss').skipped"
                            :items="['Non concerné']"
                            chips
                            :value="'Non concerné'"
                            label="Critères d'accessibilité pour déficience auditive"
                            outlined>
            </v-autocomplete>

            <v-autocomplete v-if="hasFamilyElement('AccessibilityCriteriaForPeopleWithReducedMobility') &&
            (accessibilityCriteriaForPeopleWithReducedMobility.length > 0 ||
            !getField('AccessibilityCriteriaForPeopleWithReducedMobility').skipped)"
                :value="accessibilityCriteriaForPeopleWithReducedMobility"
                :items="getFamilyByCode('AccessibilityCriteriaForPeopleWithReducedMobility')" chips
                @change="updateOrDeleteElement($event, 'accessibilityCriteriaForPeopleWithReducedMobility')"
                deletable-chips label="Critères d'accessibilité pour déficience à mobilité réduite" item-text="label"
                return-object multiple outlined>
            </v-autocomplete>

            <v-autocomplete v-else-if="hasFamilyElement('AccessibilityCriteriaForPeopleWithReducedMobility') &&
             getField('AccessibilityCriteriaForPeopleWithReducedMobility').skipped &&
             accessibilityCriteriaForPeopleWithReducedMobility.length === 0"
                            :items="['Non concerné']"
                            chips
                            :value="'Non concerné'"
                            label="Critères d'accessibilité pour déficience à mobilité réduite"
                            outlined>
            </v-autocomplete>

            <v-autocomplete v-if="hasFamilyElement('AccessibilityCriteriaForVisualImpairment') &&
            (accessibilityCriteriaForVisualImpairment.length > 0 ||
            !getField('AccessibilityCriteriaForVisualImpairment').skipped)"
                :value="accessibilityCriteriaForVisualImpairment"
                :items="getFamilyByCode('AccessibilityCriteriaForVisualImpairment')" chips
                @change="updateOrDeleteElement($event, 'accessibilityCriteriaForVisualImpairment')" deletable-chips
                label="Critères d'accessibilité pour déficience visuelle" item-text="label" return-object multiple
                outlined>
            </v-autocomplete>

            <v-autocomplete v-else-if="hasFamilyElement('AccessibilityCriteriaForVisualImpairment') &&
            accessibilityCriteriaForVisualImpairment.length === 0 &&
            getField('AccessibilityCriteriaForVisualImpairment').skipped"
                            :items="['Non concerné']"
                            chips
                            :value="'Non concerné'"
                            label="Critères d'accessibilité pour déficience visuelle"
                            outlined>
            </v-autocomplete>

            <v-autocomplete v-if="hasFamilyElement('AccessibilityCriteriaForMentalImpairment') &&
             (accessibilityCriteriaForMentalImpairment.length > 0 ||
             !getField('AccessibilityCriteriaForMentalImpairment').skipped)"
                :value="accessibilityCriteriaForMentalImpairment"
                :items="getFamilyByCode('AccessibilityCriteriaForMentalImpairment')" chips
                @change="updateOrDeleteElement($event, 'accessibilityCriteriaForMentalImpairment')" deletable-chips
                label="Critères d'accessibilité pour déficience mentale" item-text="label" return-object multiple
                outlined>
            </v-autocomplete>

            <v-autocomplete v-else-if="hasFamilyElement('AccessibilityCriteriaForMentalImpairment') &&
            accessibilityCriteriaForMentalImpairment.length === 0 &&
            getField('AccessibilityCriteriaForMentalImpairment').skipped"
                            :items="['Non concerné']"
                            chips
                            :value="'Non concerné'"
                            label="Critères d'accessibilité pour déficience mentale"
                            outlined>
            </v-autocomplete>

            <v-text-field v-if="hasField('NB_WHEELCHAIR_SIMULTANEOUSLY_AVAILABLE')"
                label="Nombre de personnes pouvant être accueillies simultanément en fauteuil roulant"
                v-model="nbWheelchairSimultaneouslyAvailable"
                @change="updateNumericFields([$event, 'NB_WHEELCHAIR_SIMULTANEOUSLY_AVAILABLE'])" type="number"
                outlined>
            </v-text-field>

            <v-textarea v-if="hasField('DESC_HAND_AUDITIF')" class="textarea" label="Descriptif handicap auditif"
                :value="frenchDescHandiAuditif" @change="updateDescHandiAuditif" outlined>
            </v-textarea>

            <v-textarea v-if="hasField('DESC_HAND_MOTEUR')" class="textarea" label="Descriptif handicap moteur"
                :value="frenchDescHandiMoteur" @change="updateDescHandiMoteur" outlined>
            </v-textarea>

            <v-textarea v-if="hasField('DESC_HAND_VISUEL')" class="textarea" label="Descriptif handicap visuel"
                :value="frenchDescHandiVisuel" @change="updateDescHandiVisuel" outlined>
            </v-textarea>

            <v-textarea v-if="hasField('DESC_HAND_MENTAL')" class="textarea" label="Descriptif handicap mental"
                :value="frenchDescHandiMental" @change="updateDescHandiMental" outlined>
            </v-textarea>


        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex"
import _ from "lodash"

export default {
    name: "Handicapped",
    props: ['languages'],
    data() {
        return {
            langues: [],
            labelTourismeHandicap: [],
            accessibilityCriteriaForHearingLoss: [],
            accessibilityCriteriaForPeopleWithReducedMobility: [],
            accessibilityCriteriaForVisualImpairment: [],
            accessibilityCriteriaForMentalImpairment: [],
            disabledReception: null,
            nbWheelchairSimultaneouslyAvailable: null
        }
    },
    methods: {
        ...mapMutations('web_form', [
            'updateContent', 'addElement', 'removeElement', 'updateProvider', 'updateBooleanElement',
            'pushBooleanElement', 'updateNumericFields', 'pushNumericField'
        ]),
        hasFieldToDisplay() {
            return this.hasField('DESC_HAND_AUDITIF') ||
                this.hasField('DESC_HAND_MOTEUR') ||
                this.hasField('DESC_HAND_VISUEL') ||
                this.hasField('DESC_HAND_MENTAL') ||
                this.hasField('DISABLED_RECEPTION') ||
                this.hasFamilyElement('AccessibilityCriteriaForHearingLoss') ||
                this.hasFamilyElement('AccessibilityCriteriaForPeopleWithReducedMobility') ||
                this.hasFamilyElement('AccessibilityCriteriaForVisualImpairment') ||
                this.hasFamilyElement('AccessibilityCriteriaForMentalImpairment') ||
                this.hasField('NB_WHEELCHAIR_SIMULTANEOUSLY_AVAILABLE') ||
                this.hasFamilyElement('LabelTourismeHandicap')
        },
        getContentByLanguage(language) {
            return this.provider.contents.find(content => content.language.code === language)
        },
        setContents() {
            let language = this.languages.find(lg => lg.code = 'fr')

            let providerContent = this.getContentByLanguage(language.code)

            let handiAuditifContent = providerContent !== undefined ? providerContent.desc_handi_auditif : null
            let handiMoteurContent = providerContent !== undefined ? providerContent.desc_handi_moteur : null
            let handiVisuelContent = providerContent !== undefined ? providerContent.desc_handi_visuel : null
            let handiMentalContent = providerContent !== undefined ? providerContent.desc_handi_mental : null

            let content = this.provider.contents.find(content => content.language.code === 'fr')

            if (providerContent === null || providerContent === undefined) {
                content = {
                    language: language,
                    desc_handi_auditif: handiAuditifContent,
                    desc_handi_moteur: handiMoteurContent,
                    desc_handi_visuel: handiVisuelContent,
                    desc_handi_mental: handiMentalContent
                }

                this.provider.contents.push(content)
            } else {
                providerContent.desc_handi_auditif = handiAuditifContent
                providerContent.desc_handi_moteur = handiMoteurContent
                providerContent.desc_handi_visuel = handiVisuelContent
                providerContent.desc_handi_mental = handiMentalContent
            }
        },
        setNumericField() {
            if (this.provider.numeric_fields !== null && this.provider.numeric_fields !== undefined) {
                let found = false

                this.provider.numeric_fields.forEach(numericField => {
                    if (numericField.attribute.code === 'NB_WHEELCHAIR_SIMULTANEOUSLY_AVAILABLE') {
                        this.nbWheelchairSimultaneouslyAvailable = numericField.value

                        found = true
                    }
                })

                if (!found) {
                    let numericField = {
                        attribute: {
                            code: 'NB_WHEELCHAIR_SIMULTANEOUSLY_AVAILABLE'
                        },
                        value: null
                    }
                    this.pushNumericField(numericField)
                }
            }
        },
        updateOrDeleteElement(newElements, property) {
            let currentElements = this[property]

            if (currentElements.length > newElements.length) {  // Cas suppression
                this.deleteElement(currentElements, newElements)
            } else { // Cas Ajout
                this.addNewElement(currentElements, newElements)
            }

            this[property] = newElements
        },
        addNewElement(currentElements, newElements) {
            let element = newElements
            const previousValue = JSON.parse(JSON.stringify(currentElements))

            if (Array.isArray(newElements)) {
                let diff = newElements.filter(_element => !previousValue.includes(_element)) || []

                if (diff.length) {
                    element = diff[diff.length - 1]
                }
            } else if (previousValue) {
                this.removeElement(previousValue)
            }

            this.addElement(element)
        },
        deleteElement(currentElements, newElements) {
            const previousValue = JSON.parse(JSON.stringify(currentElements))

            const diff = previousValue.filter(element => {
                return !newElements.map(elt => elt.id).includes(element.id)
            }) || []

            let element = newElements

            if (diff.length) {
                element = diff[diff.length - 1]
            }

            this.removeElement(element)
        },
        updateDescHandiAuditif(value) {
            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    content.desc_handi_auditif = value
                }
            })
        },
        updateDescHandiMoteur(value) {
            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    content.desc_handi_moteur = value
                }
            })
        },
        updateDescHandiVisuel(value) {
            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    content.desc_handi_visuel = value
                }
            })
        },
        updateDescHandiMental(value) {
            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    content.desc_handi_mental = value
                }
            })
        },

    },
    computed: {
        ...mapState('web_form', ['provider', 'disabled']),
        ...mapGetters('web_form', ['hasField', 'hasFamilyElement', 'getFamilyByCode', 'getElementsByFamilyCode', 'getField']),
        frenchDescHandiAuditif() {
            let _content = {}

            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    _content = content
                }
            })

            return _content.desc_handi_auditif
        },
        frenchDescHandiMoteur() {
            let _content = {}

            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    _content = content
                }
            })

            return _content.desc_handi_moteur
        },
        frenchDescHandiVisuel() {
            let _content = {}

            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    _content = content
                }
            })

            return _content.desc_handi_visuel
        },
        frenchDescHandiMental() {
            let _content = {}

            this.provider.contents.forEach(content => {
                if (content.language.code === 'fr') {
                    _content = content
                }
            })

            return _content.desc_handi_mental
        }
    },
    watch: {
        provider: {
            handler: _.debounce(function () {
                this.updateProvider(this.provider)
            }, 200),
            deep: true
        }
    },
    created() {
        this.langues = this.getElementsByFamilyCode('Langue')
        this.labelTourismeHandicap = this.getElementsByFamilyCode('LabelTourismeHandicap')

        this.accessibilityCriteriaForHearingLoss = this.getElementsByFamilyCode('AccessibilityCriteriaForHearingLoss')
        this.accessibilityCriteriaForPeopleWithReducedMobility = this.getElementsByFamilyCode('AccessibilityCriteriaForPeopleWithReducedMobility')
        this.accessibilityCriteriaForVisualImpairment = this.getElementsByFamilyCode('AccessibilityCriteriaForVisualImpairment')
        this.accessibilityCriteriaForMentalImpairment = this.getElementsByFamilyCode('AccessibilityCriteriaForMentalImpairment')

        this.disabledReception = String(null)

        this.setContents()
        this.setNumericField()

        if (this.provider.boolean_elements !== null && this.provider.boolean_elements !== undefined) {
            let found = false

            this.provider.boolean_elements.forEach(booleanElement => {
                if (booleanElement.attribute.code === 'DISABLED_RECEPTION') {
                    this.disabledReception = booleanElement.value ?? String(booleanElement.value)

                    found = true
                }
            })

            if (!found) {
                let booleanElement = {
                    attribute: {
                        code: 'DISABLED_RECEPTION'
                    },
                    value: "null"
                }
                this.pushBooleanElement(booleanElement)
            }
        }
    }
}
</script>
